import React, { useEffect, useRef } from 'react'
import * as E from '../elementor'
import parse from 'html-react-parser'
import { register } from 'swiper/element/bundle'

import 'swiper/scss'
import 'swiper/scss/scrollbar'
import 'swiper/scss/navigation'
register()

interface Props {
  section: E.Section
}

export const TherapyCards: React.FC<Props> = ({ section }) => {
  const { textEditor, heading, image, button } = E.collect(section)

  const mainHeading = heading.shift()
  const mainSubHeading = textEditor.shift()

  const swiperRef = useRef(null)

  useEffect(() => {
    const swiperContainer = swiperRef.current
    const params = {
      slidesPerView: 4,
      scrollbar: true,
      centerInsufficientSlides: true,
      breakpoints: {
        0: {
          slidesPerView: 1,
          centeredSlides: true
        },
        400: {
          slidesPerView: 1.3
        },
        600: {
          slidesPerView: 2
        },
        1000: {
          slidesPerView: 3
        },
        1300: {
          slidesPerView: 4
        }
      },
      injectStyles: [
        `
        .swiper-wrapper {
          margin-bottom: 3rem;
          padding-top: 8px;
        }
        .swiper-scrollbar {
          background: #f5f5f5;
        }
        .swiper-scrollbar.swiper-scrollbar-horizontal {
          height: 2px;
        }
        .swiper-scrollbar-drag {
          background: #262626;
        }
      `
      ]
    }

    if (swiperContainer !== undefined && swiperContainer !== null) {
      Object.assign(swiperContainer, params);
      (swiperContainer as any).initialize()
    }
  }, [])

  return (
    <div className='therapy-cards'>
      <div className='therapy-cards-content'>
        <h2 className='headline'>
          {parse(mainHeading?.title || '')}
        </h2>
        <p className='subheadline'>
          {mainSubHeading?.parse()}
        </p>
      </div>
      <div className='cards'>
        <swiper-container slidesPerView='4' navigation='false' ref={swiperRef} init='false'>
          {
          heading.map((heading, idx) => {
            return (
              <swiper-slide>
                <a href={button[idx]?.link} id={button[idx]?.button_css_id || ''}>
                  <div className='card'>
                    <div className='card-content'>
                      <img src={image[idx]?.image?.fileUrl} alt='' />
                      <h3 className='card-heading'>
                        {parse(heading?.title || '')}
                      </h3>
                      <div className='card-text'>
                        {textEditor[idx]?.parse()}
                      </div>
                    </div>
                    <a href={button[idx]?.link}>
                      <button className='rula-button'>
                        {button[idx]?.text}
                      </button>
                    </a>
                  </div>
                </a>
              </swiper-slide>
            )
          })
        }
        </swiper-container>
      </div>
    </div>
  )
}

export default TherapyCards
